/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevTelemetryErrorDto
 */
export interface DevTelemetryErrorDto {
    /**
     * 
     * @type {Date}
     * @memberof DevTelemetryErrorDto
     */
    occurredAt: Date;
    /**
     * 
     * @type {string}
     * @memberof DevTelemetryErrorDto
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof DevTelemetryErrorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DevTelemetryErrorDto
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevTelemetryErrorDto
     */
    exceptionType: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevTelemetryErrorDto
     */
    exceptionMessage: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevTelemetryErrorDto
     */
    httpStatusCode: number | null;
    /**
     * 
     * @type {string}
     * @memberof DevTelemetryErrorDto
     */
    traceId: string;
}

/**
 * Check if a given object implements the DevTelemetryErrorDto interface.
 */
export function instanceOfDevTelemetryErrorDto(value: object): value is DevTelemetryErrorDto {
    if (!('occurredAt' in value) || value['occurredAt'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('exceptionType' in value) || value['exceptionType'] === undefined) return false;
    if (!('exceptionMessage' in value) || value['exceptionMessage'] === undefined) return false;
    if (!('httpStatusCode' in value) || value['httpStatusCode'] === undefined) return false;
    if (!('traceId' in value) || value['traceId'] === undefined) return false;
    return true;
}

export function DevTelemetryErrorDtoFromJSON(json: any): DevTelemetryErrorDto {
    return DevTelemetryErrorDtoFromJSONTyped(json, false);
}

export function DevTelemetryErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevTelemetryErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'occurredAt': (new Date(json['occurredAt'])),
        'source': json['source'],
        'name': json['name'],
        'description': json['description'],
        'exceptionType': json['exceptionType'],
        'exceptionMessage': json['exceptionMessage'],
        'httpStatusCode': json['httpStatusCode'],
        'traceId': json['traceId'],
    };
}

export function DevTelemetryErrorDtoToJSON(json: any): DevTelemetryErrorDto {
    return DevTelemetryErrorDtoToJSONTyped(json, false);
}

export function DevTelemetryErrorDtoToJSONTyped(value?: DevTelemetryErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'occurredAt': ((value['occurredAt']).toISOString()),
        'source': value['source'],
        'name': value['name'],
        'description': value['description'],
        'exceptionType': value['exceptionType'],
        'exceptionMessage': value['exceptionMessage'],
        'httpStatusCode': value['httpStatusCode'],
        'traceId': value['traceId'],
    };
}

